exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".buttonContainer-3A-O1 {\n  padding: 10px 0;\n}\n.panel-2_t7f {\n  background: #f9f9f9;\n  padding: 12px;\n  margin-bottom: 12px;\n}", ""]);

// Exports
exports.locals = {
	"buttonContainer": "buttonContainer-3A-O1",
	"panel": "panel-2_t7f"
};